import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-scheduled-event-dialog",
	templateUrl: "./scheduled-event-dialog.component.html",
	styleUrls: ["./scheduled-event-dialog.component.css"],
})
export class ScheduledEventDialogComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		this.EventDescription = this.dialogConfig.data.EventDescription;

		if (this.EventDescription != undefined) {
			this.EventDescShort = this.EventDescription.EventDescShort == undefined ? "" : this.EventDescription.EventDescShort;
		}
	}

	/////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////

	EventDescription: any;
	EventDescShort: any = "";

	EventOption: any = "Event"; //Event or Schedule

	/////////////////////////////////////////////////////

	/////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////
	onConfirm() {
		this.ref.close(this.EventOption);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////
}
